import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { clearAllAuthStorage, isEhrLaunchEnabled } from './ehrLaunchStorage'
import { EhrLaunchErrorPage } from './EhrLaunchErrorPage'
import { trackEvent } from '../../common/utils/analytics'

export const navigateToEhrLaunchStart = (url: string) => {
  window.location.href = url
}

interface EhrLaunchPageProps {
  navigateToStart?: (url: string) => void
}

export const EhrLaunchPage = ({
  navigateToStart = navigateToEhrLaunchStart,
}: EhrLaunchPageProps) => {
  const location = useLocation()
  const params = useMemo(() => new URLSearchParams(location.search), [location.search])
  const iss = params.get('iss')
  const launch = params.get('launch')
  const enabled = isEhrLaunchEnabled()

  useEffect(() => {
    if (!enabled || !iss || !launch) {
      trackEvent('ehr_launch', {
        result: 'failed',
        reason: enabled ? 'missing_launch_params' : 'disabled',
      })
      return
    }

    clearAllAuthStorage()
    const startUrl = new URL('/auth/ehr-launch/start', process.env.REACT_APP_API_BASE_URL || '')
    startUrl.searchParams.set('iss', iss)
    startUrl.searchParams.set('launch', launch)
    trackEvent('ehr_launch', { result: 'started' })
    navigateToStart(startUrl.toString())
  }, [enabled, iss, launch, navigateToStart])

  if (!enabled) {
    return <EhrLaunchErrorPage title="EHR launch is unavailable" />
  }

  if (!iss || !launch) {
    return <EhrLaunchErrorPage />
  }

  return null
}
